import React from 'react';

const CancelIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m8 14c-1.294 0-2.49-.416-3.47133333-1.1146667l8.35666663-8.35666663c.6986667.98133333 1.1146667 2.17733333 1.1146667 3.47133333 0 3.3086667-2.6913333 6-6 6m0-12c1.294 0 2.49.416 3.4713333 1.11466667l-8.35666663 8.35666663c-.69866667-.9813333-1.11466667-2.1773333-1.11466667-3.4713333 0-3.308 2.69133333-6 6-6m0-2c-4.41133333 0-8 3.58866667-8 8 0 4.4113333 3.58866667 8 8 8 4.4113333 0 8-3.5886667 8-8 0-4.41133333-3.5886667-8-8-8" fillRule="evenodd" /></svg>
);

export default CancelIcon;
